import axiosInstance from "../api/axiosConfig";

export const login = async (otp, msisdn) => {
  try {
    const response = await axiosInstance.post("/auth/login", {
      otp,
      msisdn,
    });
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const logout = async () => {
  try {
    localStorage.clear();
    await axiosInstance.post("/auth/logout");
  } catch (e) {
    throw e;
  }
};

export const getSessionUserType = async () => {
  try {
    const response = await axiosInstance.get("/auth/user-type");
    return response.data;
  } catch (e) {
    throw e;
  }
};
